import * as React from 'react';

export const AcknowledgementsTab = () => {
  return <div>TBA tab content: AcknowledgementsTab</div>;
};
